import type { PeriodUnitListPreset } from '@/package';

export const WORKTIME_PERIOD_UNIT = {
  DAILY: {
    label: 'statistics.periodDailyLabel.atropic',
    value: 'day',
  } as PeriodUnitListPreset[number],
  WEEKLY: {
    label: 'statistics.periodWeeklyLabel.gallipot',
    value: 'week',
  } as PeriodUnitListPreset[number],
  MONTHLY: {
    label: 'statistics.periodMonthlyLabel.tonsillolith',
    value: 'month',
  } as PeriodUnitListPreset[number],
};
